module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticClass: "ma-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-progress-linear', {
    attrs: {
      "rounded": "",
      "height": "32",
      "value": _vm.counter.mitLeibvater / (_vm.counter.mitLeibvater + _vm.counter.ohneLeibvater) * 100
    }
  }, [_vm._v("\n      Aktueller Stand: " + _vm._s(_vm.counter.mitLeibvater) + " von " + _vm._s(_vm.counter.mitLeibvater + _vm.counter.ohneLeibvater) + " Leibvätern eingetragen (" + _vm._s((_vm.counter.mitLeibvater / (_vm.counter.mitLeibvater + _vm.counter.ohneLeibvater) * 100).toFixed(1)) + " %).\n      ")])], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": "",
      "height": "calc(100vh - 170px)"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "semester"
  }, [_vm._v("Semester")]), _vm._v(" "), _c('th', [_vm._v("Receptionen")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.semester), function(semest) {
    return _c('tr', {
      key: semest.semesterID
    }, [_c('td', {
      staticClass: "semester",
      attrs: {
        "width": "90px"
      }
    }, [_c('span', [_vm._v(_vm._s(semest.semestername))])]), _vm._v(" "), _c('td', _vm._l((semest.receptionen), function(bbr) {
      return _c('v-btn', {
        key: bbr.ID,
        staticClass: "body-2",
        attrs: {
          "min-width": "200px",
          "text": ""
        },
        on: {
          "click": function($event) {
            return _vm.showModal(bbr.id, bbr.leibvater)
          }
        }
      }, [_c('span', {
        staticClass: "text-capitalize",
        class: bbr.leibvater ? 'green--text' : ''
      }, [_vm._v(_vm._s(bbr.name) + " ")])])
    }), 1)])
  }), 0)])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "500",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.modal),
      callback: function($$v) {
        _vm.modal = $$v
      },
      expression: "modal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n        Leibvater auswählen\n      ")]), _vm._v(" "), _c('v-card-text', [_c('v-autocomplete', {
    attrs: {
      "hide-details": "",
      "dense": "",
      "outlined": "",
      "items": _vm.bundesbruder,
      "placeholder": "Bisher wurde kein Leibvater ausgewählt"
    },
    model: {
      value: (_vm.leibvater),
      callback: function($$v) {
        _vm.leibvater = $$v
      },
      expression: "leibvater"
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.modal = false
      }
    }
  }, [_vm._v("\n          Abbrechen\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n          Speichern\n        ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55ddbfa8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Stammbaum/Daten.vue
// module id = 782
// module chunks = 15